<ng-lottie
    [options] = "animationOptions"
    [styles] = "animationStyles">
</ng-lottie>